require("core-js/modules/es6.regexp.replace");

var makeString = require('./helper/makeString');

module.exports = function swapCase(str) {
  return makeString(str).replace(/\S/g, function (c) {
    return c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase();
  });
};